export default __webpack_public_path__ + "static/media/addnew-icon2.e27c277d.svg";